"use client";

import { motion } from "framer-motion";
import { FeatureCard } from "./FeatureCard";
import { Products } from "@/types/productsTypes";

export default function MarketplaceHero({ section }: { section: Products['atlasmarketplace']["hero"] }) {
    return (
        <section className="section-primary text-center">
            <div className="max-w-7xl mx-auto">
                <motion.div 
                    className="text-center mb-12"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ staggerChildren: 0.2, delayChildren: 0.1 }}
                >
                    <motion.p
                        variants={{
                            hidden: { opacity: 0, y: 20 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        className="w-fit mx-auto badge-size section-badge mb-1"
                    >
                        {section.badge}
                    </motion.p>
                    
                    <motion.h1 
                        className="title-size font-bold mb-3 text-bg"
                        variants={{
                            hidden: { opacity: 0, y: 30 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                    >
                        {section.title}
                    </motion.h1>
                    
                    <motion.p 
                        className="text-size text-muted-foreground mb-8 max-w-2xl mx-auto"
                        variants={{
                            hidden: { opacity: 0, y: 20 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                    >
                        {section.description}
                    </motion.p>
                </motion.div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {section.cards.map((card, idx) => (
                        <FeatureCard
                            key={idx}
                            content={card}
                            idx={idx}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
} 